import React from 'react';
import { Loader2, Clock, Eye, LogOut, Lock, Trash2, Plus, Upload, FileText } from 'lucide-react';

export default function ActivityTab({ auditLog, auditLoading, auditTotal, auditPage, fetchAuditLog }) {
  return (
    <div data-testid="activity-log-section">
      <div className="bg-[#2a2a2a] rounded-lg overflow-hidden">
        {auditLoading ? (
          <div className="flex items-center justify-center py-16">
            <Loader2 className="w-6 h-6 animate-spin text-emerald-500" />
          </div>
        ) : auditLog.length === 0 ? (
          <div className="text-center py-16 text-gray-400">
            <Clock className="w-10 h-10 mx-auto mb-3 text-gray-600" />
            <p>No activity recorded yet.</p>
          </div>
        ) : (
          <>
            <div className="divide-y divide-gray-700/50">
              {auditLog.map((entry, i) => (
                <div key={i} className="px-5 py-3.5 flex items-center gap-4 hover:bg-[#333] transition-colors" data-testid={`audit-entry-${i}`}>
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${
                    entry.action === 'login' ? 'bg-blue-500/15 text-blue-400' :
                    entry.action === 'logout' ? 'bg-gray-500/15 text-gray-400' :
                    entry.action === 'password_change' ? 'bg-amber-500/15 text-amber-400' :
                    entry.action.includes('delete') ? 'bg-red-500/15 text-red-400' :
                    entry.action.includes('create') ? 'bg-emerald-500/15 text-emerald-400' :
                    entry.action.includes('publish') ? 'bg-purple-500/15 text-purple-400' :
                    'bg-white/5 text-white/40'
                  }`}>
                    {entry.action === 'login' ? <Eye className="w-4 h-4" /> :
                     entry.action === 'logout' ? <LogOut className="w-4 h-4" /> :
                     entry.action === 'password_change' ? <Lock className="w-4 h-4" /> :
                     entry.action.includes('delete') ? <Trash2 className="w-4 h-4" /> :
                     entry.action.includes('create') ? <Plus className="w-4 h-4" /> :
                     entry.action.includes('publish') ? <Upload className="w-4 h-4" /> :
                     <FileText className="w-4 h-4" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-white text-sm font-medium">
                      {entry.action.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                    </p>
                    <p className="text-gray-400 text-xs truncate">
                      {entry.details?.title ? `"${entry.details.title}" · ` : ''}{entry.admin_email}
                    </p>
                  </div>
                  <span className="text-gray-500 text-xs whitespace-nowrap">
                    {new Date(entry.at).toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                  </span>
                </div>
              ))}
            </div>
            {auditTotal > 20 && (
              <div className="flex items-center justify-between px-5 py-3 border-t border-gray-700">
                <span className="text-gray-500 text-xs">{auditTotal} total entries</span>
                <div className="flex gap-2">
                  <button
                    onClick={() => fetchAuditLog(auditPage - 1)}
                    disabled={auditPage <= 1}
                    className="px-3 py-1 text-xs bg-[#1a1a1a] border border-gray-600 rounded text-gray-300 disabled:opacity-30 hover:bg-[#333] transition-colors"
                    data-testid="audit-prev-page"
                  >
                    Previous
                  </button>
                  <span className="px-3 py-1 text-xs text-gray-400">Page {auditPage}</span>
                  <button
                    onClick={() => fetchAuditLog(auditPage + 1)}
                    disabled={auditPage * 20 >= auditTotal}
                    className="px-3 py-1 text-xs bg-[#1a1a1a] border border-gray-600 rounded text-gray-300 disabled:opacity-30 hover:bg-[#333] transition-colors"
                    data-testid="audit-next-page"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
